<template>
  <li>
    {{ cartStore.numberOfItems }}
  </li>
</template>

<script>
  import { useCartStore } from '~/stores/cart';

  export default {
    setup() {
      const cartStore = useCartStore();
      return { cartStore };
    },
    created() {
      this.cartStore.fetchCart();
    },
  };
</script>
